export default __webpack_public_path__ + "static/media/thought_left_img.0e78d480.jpg";